module.exports = __webpack_public_path__ + "static/media/beneficiary-my-classes-empty-state.6e90a387.svg";